import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button, Divider } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Breadcrumbs } from '../../components/Breadcrumbs'
import { BreadcrumbsHelper } from '../../helpers/BreadcrumbsHelper';
import { SelectComponentV2 } from '../../components/SelectComponentV2';
import { CheckboxComponent } from '../../components/CheckboxComponent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Popover from '@material-ui/core/Popover';
import InputAdornment from '@material-ui/core/InputAdornment';
import MomentUtils from '@date-io/moment';
import momentTz from 'moment-timezone';
import { AppTheme } from '../../styles/AppTheme';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import { AppConfig } from '../../AppConfig';
import Switch from '@material-ui/core/Switch';
import moment from 'moment';
import { adminData } from '../../data/AdminData.js'
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { AppHelper } from '../../helpers/AppHelper';
import { DateRangePicker } from './DateRangePicker';
import { MultiCamPicker } from './MultiCamPicker'
import { EventFilter } from './EventFilter'
import { EventRefreshController } from './EventRefreshController'
import { Toggler } from '../../common/components/Toggler';
import { EventDownloadReport } from './EventDownloadReport';
import { ViewSummaryButton } from './ViewSummaryButton';

export class EventActionHeaderbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  renderBackBtn = () => {
    if (this.props.backPathName) {
      return (
        <Link
          to={{ pathname: this.props.backPathName }}
          className={css(Styles.link)}>
          <div className={css(CommonStyles.headerMemberAddContainer, CommonStyles.backButton)} >
            <img src={require('../../assets/images/back-img.svg')} className={css(CommonStyles.addImg)} />
            <p className={css(CommonStyles.margin)}>BACK</p>
          </div>
        </Link>
      )
    }
  }

  render() {
    return (
      <div>
        <div className={this.props.relativeImageSliderMode ? css(CommonStyles.outerHeaderContainer, Styles.withOpacity) : css(CommonStyles.outerHeaderContainer)}>
          <div className={css(CommonStyles.innerHeaderContainer, CommonStyles.innerHeaderContainerCustom)}>
            <div className={css(CommonStyles.innerHeaderFirstContainer)}>
              {this.renderBackBtn()}

              {(this.props.breadcrumbs || this.props.title) &&
                <div className={css(CommonStyles.headerOrgOuterContainer, Styles.headerOrgOuterContainer)}>
                  <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.title}</p>
                  {this.props.breadcrumbs &&
                    <Breadcrumbs items={this.props.breadcrumbs} />
                  }
                </div>
              }

              {this.props.placePicker &&
                <CheckboxComponent
                  headerView={true}
                  formField={this.props.placePicker}
                  value={this.props.selectedPlaceIds}
                  setValue={this.props.placeSelectHandler}
                  disabled={false} />
              }

              {this.props.camPicker &&
                <CheckboxComponent
                  headerView={true}
                  formField={this.props.camPicker}
                  value={this.props.selectedCamIds}
                  setValue={this.props.camSelectHandler}
                  disabled={false} />
              }

              {(!this.props.camPicker && !this.props.hideCamPicker) &&
                <MultiCamPicker
                  place={this.props.place}
                  camSelectHandler={this.props.camSelectHandler}
                  selectedCamIds={this.props.selectedCamIds}
                />
              }
            </div>
            {!this.props.hideDateRangePicker &&
              <DateRangePicker
                timeChangeHandler={this.props.timeChangeHandler}
                fromDateTs={this.props.fromDateTs}
                toDateTs={this.props.toDateTs}
              />
            }
            {!this.props.hideFilter &&
              <EventFilter
                priorityFilters={this.props.priorityFilters}
                tagFilters={this.props.tagFilters}
                filterTagValue={this.props.filterTagValue}
                filterHandler={this.props.filterHandler}
                place={this.props.place}
              />
            }

            <div className={css(Styles.headerMemberOuterContainer)}>

              {this.props.showDownload &&
                <EventDownloadReport
                  downloadReport={() => this.props.downloadReport()}
                />
              }

              {this.props.showSummaryButton &&
                (this.props.selectedCamIds && this.props.selectedCamIds.length < 2) &&
                <ViewSummaryButton
                  showStatsHandler={this.props.showStatsHandler}
                  showStats={this.props.showStats}
                />
              }

              {this.props.eventRefreshHandler &&
                <EventRefreshController
                  eventRefreshHandler={this.props.eventRefreshHandler}
                />
              }

              {this.props.onGroupedDisplayChange &&
                <Toggler
                  defaultMode={true}
                  title={'GROUP'}
                  toolTip={'GROUPED DISPLAY'}
                  onChange={this.props.onGroupedDisplayChange}
                />
              }
            </div>

          </div>
        </div>

        {/*<div className={this.props.relativeImageSliderMode ? css(CommonStyles.outerHeaderContainerNextRow, Styles.withOpacity) : css(CommonStyles.outerHeaderContainerNextRow)}>
          <div className={css(CommonStyles.innerHeaderContainerNextRow, CommonStyles.innerHeaderContainerCustom)}>
            {!this.props.hideFilter &&
              <EventFilter
                priorityFilters={this.props.priorityFilters}
                tagFilters={this.props.tagFilters}
                filterTagValue={this.props.filterTagValue}
                filterHandler={this.props.filterHandler}
                place={this.props.place}
              />
            }
            {this.props.showDownload &&
              <EventDownloadReport
                downloadReport={() => this.props.downloadReport()}
              />
            }
            {this.props.showSummaryButton &&
              (this.props.selectedCamIds && this.props.selectedCamIds.length < 2) &&
              <ViewSummaryButton
                showStatsHandler={this.props.showStatsHandler}
                showStats={this.props.showStats}
              />
            }
          </div>
        </div>*/}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/screens/ClientPlace/EventActionHeaderBar.js